<template>
  <div
    v-if="currentUser && currentUser.permissions['SUPPLIER_CONTACT']"
    class="supplier-contacts-listing"
  >
    <SupplierContactsActions />

    <div class="radio-control">
      <div class="multi-inline">
        <span class="radio-label">
          <label>{{ $t('supplierContacts.labels.filter') }}</label>
        </span>
        <TolRadioButton
          :button-label="$t('supplierContacts.labels.active')"
          label="true"
          name="activeInactive"
          :value="activeInactive"
          @toggle="onActiveInactiveChange"
        />
        <TolRadioButton
          :button-label="$t('supplierContacts.labels.inactive')"
          label="false"
          name="activeInactive"
          :value="activeInactive"
          @toggle="onActiveInactiveChange"
        />
        <TolRadioButton
          :button-label="$t('supplierContacts.labels.both')"
          label="both"
          name="activeInactive"
          :value="activeInactive"
          @toggle="onActiveInactiveChange"
        />
      </div>
    </div>

    <tol-table
      :table-data="supplierContacts"
      :columns="columns"
      :is-row-clickable="true"
      @row-click="handleRowClick($event)"
    >
      <template v-slot:tableHeader>
        <th-sortable
          :direction="currentSortField === 'display_name' ? currentSortDirection : 'none'"
          field-name="display_name"
          @change="onSortOrderChange"
          >{{ $t('supplierContacts.listing.labels.display_name') }}</th-sortable
        >

        <th-sortable
          :direction="currentSortField === 'supplier' ? currentSortDirection : 'none'"
          field-name="supplier"
          @change="onSortOrderChange"
          >{{ $t('supplierContacts.listing.labels.supplier') }}</th-sortable
        >

        <th-sortable
          :direction="currentSortField === 'email' ? currentSortDirection : 'none'"
          field-name="email"
          @change="onSortOrderChange"
          >{{ $t('supplierContacts.listing.labels.email') }}</th-sortable
        >
      </template>
    </tol-table>

    <Pagination
      :records-per-page="supplierContactsPerPage"
      :offset="currentPage"
      :record-count="recordCount"
      @change="onChangePaginationParams($event)"
    />
  </div>
</template>

<script>
import {
  SupplierContactsListingActions,
  SupplierContactsListingGetters
} from '@/app/features/supplier-contacts/features/supplier-contacts-listing/supplier-contacts-listing.keys';
import SupplierContactsActions from '@/app/features/supplier-contacts/features/supplier-contacts-listing/components/SupplierContactsActions';
import { AppActions } from '@/app/app.keys';
import TolRadioButton from '@/app/components/TolRadioButton';
import TolTable from '@/app/components/TolTable';
import ThSortable from '@/app/components/ThSortable';
import Pagination from '@/app/components/Pagination';

export default {
  name: 'SupplierContactsListing',
  components: {
    TolTable,
    SupplierContactsActions,
    ThSortable,
    Pagination,
    TolRadioButton
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    supplierContacts() {
      return this.$store.getters[SupplierContactsListingGetters.SupplierContactsList];
    },
    supplierContactsPerPage() {
      return this.$store.getters[SupplierContactsListingGetters.SupplierContactsPerPage];
    },
    currentPage() {
      return this.$store.getters[SupplierContactsListingGetters.SupplierContactsListingOffset];
    },
    recordCount() {
      return this.$store.getters[SupplierContactsListingGetters.SupplierContactsRecordCount];
    },
    currentSortField() {
      return this.$store.getters[SupplierContactsListingGetters.SortBy];
    },
    currentSortDirection() {
      return this.$store.getters[SupplierContactsListingGetters.SortDirection];
    },
    columns() {
      return ['display_name', 'supplier', 'email'];
    },
    activeInactive() {
      return this.$store.getters[SupplierContactsListingGetters.SupplierContactsActiveInactive];
    }
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('supplierContacts.listing.title'));
    this.$store.dispatch(SupplierContactsListingActions.RetrieveSupplierContacts);
  },
  methods: {
    onSortOrderChange(sortOrder) {
      this.$store.dispatch(SupplierContactsListingActions.SetSupplierContactsSortOrder, sortOrder);
    },
    onChangePaginationParams(event) {
      this.$store.dispatch(
        SupplierContactsListingActions.SetSupplierContactsPaginationParameters,
        event
      );
    },
    onActiveInactiveChange(activeInactive) {
      this.$store.dispatch(
        SupplierContactsListingActions.SetSupplierContactsActiveInactive,
        activeInactive
      );
    },
    handleRowClick(evt) {
      this.$router.push(`/supplier-contacts/${evt.reference_number}`);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.supplier-contacts-listing {
  list-style-position: inside;
  padding-left: 0;
}

.radio-control {
  display: flex;
  padding: 10px 0;
  margin: 1em;
  flex: 1;
  justify-content: flex-end;
  align-items: flex-end;

  .tol-list ul li .remove {
    width: 30px;
    height: 30px;

    font-size: 1.2em;
    color: $row-border;
    text-align: center;
    float: right;
    &:hover {
      background-color: $row-border;
      border-radius: 100%;
      color: $white;
    }
  }

  .grey {
    color: $grey;
  }
}

.multi-inline {
  display: flex;
  justify-content: flex-start;
  align-content: center;
  background-color: $light-grey-1;
  align-items: flex-end;
  height: 100%;
  padding: 10px 10px 0px 10px;
  > span.radio-label {
    display: flex;
    font-weight: bold;
    margin-bottom: 10px;
  }

  > * {
    margin-left: 1em;
  }
  > *:first-child {
    margin-left: 0;
  }
}
</style>
